import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Localized } from '../../localization/react'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.layoutSpacing.wide,
    border: `2px solid ${theme.palette.border}`,
  },
  timer: {
    width: 100,
  },
}))

interface Props {
  timeRemainingInMilliseconds: number
}

const getFormattedTimeRemaining = (timeRemaining: number) => {
  const minutes = Math.floor(timeRemaining / 60000)
    .toFixed(0)
    .padStart(2, '0')
  const seconds = ((timeRemaining % 60000) / 1000).toFixed(0).padStart(2, '0')

  return `00:${minutes}:${seconds}`
}

const PaymentTimerComponent: React.FC<React.PropsWithChildren<Props>> = ({ timeRemainingInMilliseconds }) => {
  const classes = useStyles()
  const formattedTimeRemaining = getFormattedTimeRemaining(timeRemainingInMilliseconds)

  return (
    <Flex justifyContent="center" alignItems="center" className={classes.container} marginBottom="wide" fullWidth>
      <Heading is="h2" marginRight="wide" color="primary.main" className={classes.timer}>
        {formattedTimeRemaining}
      </Heading>
      <Text is="div" fontWeight="bold">
        <Localized id="payment-timer" />
      </Text>
    </Flex>
  )
}

export default PaymentTimerComponent
